<div class="select-wrapper flex-utility align-center" *ngIf="showSelect">
    <mat-select panelClass="custom-select-panel" #select class="page-header-select" [(ngModel)]="optionSelected"
        (valueChange)="triggerAction($event)">
        <mat-option *ngFor="let option of selectOptions" [value]="option">{{option[optionLabelProp] |
            translate}}</mat-option>
    </mat-select>
    <i *ngIf="!select.panelOpen" class="material-icons">expand_more</i>
    <i *ngIf="select.panelOpen" class="material-icons">expand_less</i>
</div>